import {nanoid} from "nanoid";
import { AppstoreOutlined, FundProjectionScreenOutlined, UserOutlined, BankOutlined, FireOutlined, BulbOutlined, CommentOutlined, TeamOutlined } from '@ant-design/icons';

const items = [
    {
        id: nanoid(),
        link: "/dashboard",
        text: "Dashboard",
        icon: <AppstoreOutlined />
    },
    {
        id: nanoid(),
        link: "/registrations",
        text: "Registrations",
        icon: <FundProjectionScreenOutlined />
    },
    {
        id: nanoid(),
        link: "/partners",
        text: "Partners",
        icon: <TeamOutlined />
    },
    {
        id: nanoid(),
        link: "/clients",
        text: "Clients",
        icon: <UserOutlined />
    },
    {
        id: nanoid(),
        link: "/delegates",
        text: "Delegates",
        icon: <BankOutlined />
    },
    {
        id: nanoid(),
        link: "/payment",
        text: "Payment",
        icon: <BankOutlined />
    },
    {
        id: nanoid(),
        link: "/missions",
        text: "Missions",
        icon: <FireOutlined />
    },
    {
        id: nanoid(),
        link: "/insights",
        text: "Insights",
        icon: <BulbOutlined />
    },
    {
        id: nanoid(),
        link: "/support",
        text: "Support",
        icon: <CommentOutlined />
    },
    {
        id: nanoid(),
        link: "/administrators",
        text: "Administrators",
        icon: <TeamOutlined />,
        requiredRole: "SUPER_ADMIN",
    },
];

export default items;
